import Vue from 'vue';
import Vuex from 'vuex';


import Datepicker from 'vuejs-datepicker';
import {en, fr} from 'vuejs-datepicker/dist/locale';
import {instance} from '@/api';
import {registerApi} from '@/api';
import Multiselect from 'vue-multiselect';
import VeeInput from '@/components/ValidateInput';
import {regex} from '@/config';
import FormMessage from '@/components/parts/form-message';
import moment from 'moment-timezone';

import {mask} from 'vue-the-mask';


/*Vue.directive('input-mask', {
	bind: function (el) {
		new Inputmask().mask(el);
	},
});*/

export default {
	name: 'Register',
	directives: {mask},
	components: {
		'vee-input': VeeInput,
		Datepicker,
		'multiselect': Multiselect,
		'form-message': FormMessage,

	},
	data() {
		return {
			dates: [
				1900,
				2000
			],
			step: 0,
			stepMap: {
				'personal': 0,
				'account': 1,
				'validation': 2,
				'success': 3,
				'error': -1
			},
			config:{
				use_email_confirm: false
			},
			datepicker: {
				disabled: {
					from: new Date()
				},
				openDate: new Date(),
				date: '',
				masked: '',
				lang: {
					en: en,
					fr: fr
				}
			},
			loading: false,

			form: {
				//personal
				firstname: '',
				lastname: '',
				birthday: {
					day: '',
					month: '',
					year: ''
				},
				phone: '',


				//account
				email: '',
				email_confirmation: '',
				password: {
					p1: '',
					p2: '',
					validity1: {
						required: true,
						min: 6,
						regex: regex.password
					},
					validity2: {
						required: true,
						min: 6,
						confirmed: 'password'
					}
				},
				iban: 'LU',
				secret_question: '',
				secret_response: '',



				//validation
				newsletter: false,
				terms_and_conditions: false

			},
			//Form end

			testImg: null,

		}//
	},
	computed: {
		...Vuex.mapState([
			'lang'
		]),

		vDate(){
			return {
				required: true,
				date_format: 'dd-MM-yyyy',
				date_between: ['01-01-1905', moment().subtract(18, 'years').add(1,'day').format('DD-MM-YYYY')]
			}
		},
		ibanValidator(){
			return {
				required: true,
				regex: regex.iban,
				min: 20
			}
		}

		/*maxDate(){
			return moment().subtract(18, 'years').add(1,'day').format('DD-MM-YYYY');
		}*/
	},
	watch: {

		'datepicker.masked': function (val) {
			let date = val.split('-');

			if(date.length > 0){
				this.form.birthday.day = date[0];
			}
			if(date.length > 1){
				this.form.birthday.month = date[1];
			}
			if(date.length > 2){
				this.form.birthday.year = date[2];

				let tDate = `${date[2]}-${date[1]}-${date[0]}`;

				if(date[2].length > 3 && !isNaN(date[2]) && moment(tDate).isValid() && !this.dateCompare(new Date(this.datepicker.date), tDate) ){

					this.datepicker.date = moment( tDate ).toDate();
				}

			}


		},
		'datepicker.date': function (val) {

			if(moment(val).isValid()){
				/*let d = val.getDate();
				let m = val.getMonth() + 1;
				let y = val.getFullYear();

				let tmp  = `${d > 9 ? d : `0${d}`}-${m > 9 ? m : `0${m}`}-${y}`;*/
				this.datepicker.masked = moment(val).format('DD-MM-YYYY');
			}

		}
	},
	mounted() {

		window.re = this;
		let d = new Date();
		d.setUTCFullYear(d.getUTCFullYear() - 18);

		this.datepicker.disabled.from = this.datepicker.openDate = new Date(d);

		this.$root.$on('register:refresh',this.refreshHandler )

		//this.clearForm(true); //TODO: remove
	},
	beforeDestroy(){

		this.$root.$off('register:refresh',this.refreshHandler )

	},
	methods: {
		refreshHandler(){
			console.log('you huuu');
			this.step = 0;
			this.errors.clear();
			this.clearForm();


		},


		dateCompare(dateDate, dateString){

			return dateString === `${dateDate.getUTCFullYear()}-${dateDate.getMonth() + 1}-${dateDate.getDate()}`;
		},

		clearForm(test){

			//Fill form with test data
			if(test){
				//Temp data for tests
				Object.assign(this.form, {
					//personal
					firstname: 'Test',
					lastname: 'TestL',
					birthday: {
						day: '12',
						month: '12',
						year: '2900'
					},
					email: 'ssda@testing-only.de',
					email_confirmation: 'ssda@testing-only.de',
					password: {
						p1: '1234567890aA*',
						p2: '1234567890aA*',
						validity1: {
							required: true,
							min: 8,
							max: 50,
						},
						validity2: {
							required: true,
							min: 8,
							max: 50,
							confirmed: 'password'
						}
					},
					iban: 'LU',
					secret_question: '',
					secret_response: ''
				});
			}else{
				//Clean form data
				Object.assign(this.form, {
					//personal
					firstname: '',
					lastname: '',
					birthday: {
						day: '',
						month: '',
						year: ''
					},
					email: '',
					phone: '',
					email_confirmation: '',
					password: {
						p1: '',
						p2: ''
					},
					iban: 'LU',
					secret_question: '',
					secret_response: ''
				});
			}


		},


		stepChange(currClick) {

			//Don't forget that in form steps started from 0 (zero)
			if (this.step + 1 > currClick && !this.loading) {
				this.step = currClick - 1;
			}
		},

		validateForm(scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.deleteMessage('validation');
					// eslint-disable-next-line
					console.info('Form Submitted: ' + scope);
					switch (scope) {
						case 'personal':
							this.step = 1;
							break;
						case 'account':
							this.step = 2;
							break;
						case 'validation':
							this.postForm();
							//this.step = 3;
							break;
					}

				}
			});
		},
		postForm() {

			//Clear form from errors
			this.errors.clear();
			this.deleteMessage('validation');

			//SHow that we started loading
			this.loading = true;
			this.$store.commit('addLoad', 'registerUser');

			//Data preparation for send
			let data = Object.assign({}, this.form);

			/*let month = this.form.birthday.month < 10 ? '0'+this.form.birthday.month : this.form.birthday.month; //Backend want to have leading zero
			let day = this.form.birthday.day < 10 ? '0'+this.form.birthday.day : this.form.birthday.day;
*/
			data.birthdate = this.form.birthday.year+'-'+this.form.birthday.month+'-'+this.form.birthday.day;


			data.password = this.form.password.p1;
			data['password_confirmation'] = this.form.password.p2;

			//Backend doesn't recognize true/false as Boolean params and require 1/0
			data.newsletter = this.form.newsletter ? '1' : '0'; //Just (facepalm)  ¯\_(ツ)_/¯
			data.terms_and_conditions = this.form.terms_and_conditions ? '1' : '0';

			instance.post(registerApi.register, data)
				.then((responce) => {
					console.log(responce.data);

					//Check if we have any server validation errors
					if(responce.data.status === 'ERROR'  ){

						if(Array.isArray(responce.data.error)){
							this.processFields(responce.data.error);
						}else if(typeof responce.data === 'object' && responce.data.error){
							this.processFields([responce.data.error]);
						}


					}else if(responce.data.status === 'SUCCESS'){

						this.step = 3; // Move to success step
						this.$store.commit('setUser', responce.data.content);
						this.$router.push({ name: 'UserData' });
						this.clearForm(false);
					}

				})
				.catch((er) => {
					console.warn(er);
				})
				.then(() => {
					this.loading = false;
					this.$store.commit('endLoad', 'registerUser');
				});

		},


		processFields(fields){
			//Initial project forms validation - now it legacy


			//Set minimum step that we will return if error is present
			let minStep = this.step;
			let generalErrors = [];

			//Iterate through response validation object
			for(let i = fields.length - 1; i > -1; i-- ){

				let prop = fields[i].property;
				let path = prop;
				let found = false;

				//Iterate through scope fields
				for (let scope in this.fields) {

					//Search for failed field in scope
					for (let field in this.fields[scope]) {

						if (field === prop) {
							let s = scope.replace('$', '');
							path = s + '.' + prop; //Set path name for error

							//Check for minimum reverse back step
							if (this.stepMap[s] < minStep) {
								minStep = this.stepMap[s];
							}

							found = true;
							//Stop iterate, because we found required field
							break;
						}
					}
					if (found) {

						break;
					}
				}

				if(found){
					//Add error message to field
					this.errors.add({
						field: path,
						msg: this.t('register.'+fields[i].property+'.'+fields[i].code)
					});
				}else{
					//Field not found in form, add as general error.
					generalErrors.push(fields[i]);
				}


			}

			this.restMessageHandler('ERROR', 'validation', generalErrors, 'register');


			//KEEP
			this.step = minStep;
		},


		processFile(event, model) {
			Vue.set(model, 'file', []);
			this.encodeImageFileAsURL(event, model);
		},

		openPicker(to) {

			if(this.$refs.birthdayPicker){
				if(typeof to === 'undefined'){
					this.$refs.birthdayPicker.showCalendar();

				}else{

					if(to){
						this.$refs.birthdayPicker.showCalendar();
					}else{
						this.$refs.birthdayPicker.close();
					}
				}
			}



		},

		formatCity(option) {
			return option.name
		}


	}
}
